<template>
  <div id="paymentreminderpopup">

    <!-- Modal 1: Payment Methods -->
    <AppModal v-model="paymentmethodsVisible" position="center" :no-close-on-backdrop="true">
      <div class="w-100 flex justify-end mt-8">
        <button type="button" @click="hidemodal()" class="fs-20 bg-white border-none cursor-pointer p-0 m-0">
          <svg xmlns="http://www.w3.org/2000/svg" width="17.633" height="17.632" viewBox="0 0 17.633 17.632">
            <path d="M-3642.184-128.272a8.815,8.815,0,0,1,8.816-8.816,8.815,8.815,0,0,1,8.817,8.816,8.815,8.815,0,0,1-8.817,8.816A8.815,8.815,0,0,1-3642.184-128.272Zm3.421-5.4a7.583,7.583,0,0,0-2.234,5.4,7.583,7.583,0,0,0,2.234,5.4,7.579,7.579,0,0,0,5.4,2.234,7.576,7.576,0,0,0,5.4-2.234,7.579,7.579,0,0,0,2.234-5.4,7.579,7.579,0,0,0-2.234-5.4,7.576,7.576,0,0,0-5.4-2.234A7.579,7.579,0,0,0-3638.763-133.668Zm2.2,8.588a.655.655,0,0,1,0-.958l2.233-2.234-2.233-2.234a.654.654,0,0,1,0-.958.648.648,0,0,1,.957,0l2.234,2.234,2.234-2.234a.681.681,0,0,1,.958,0,.682.682,0,0,1,0,.958l-2.234,2.234,2.234,2.234a.673.673,0,0,1,0,.958.681.681,0,0,1-.958,0l-2.234-2.234-2.234,2.234a.678.678,0,0,1-.48.2A.671.671,0,0,1-3636.559-125.08Z" transform="translate(3642.184 137.088)" fill="#499dbb"/>
          </svg>
        </button>
      </div>

      <div class="flex w-100 m-0 p-0 flex-wrap">
        <div class="w-100 p-0 m-0 text-darkblue">
          <div class="flex flex-col w-100 p-0">
            <div class="flex flex-col payment-inner mx-auto">
              <p class="fs-24 text-darkblue" v-if="partnername">Hej {{ partnername.replace('&\#039\;', '\'') }}!</p>
              <p class="fs-16 text-darkblue">Betalingsmetoder</p>
            </div>
            <div class="payment-inner mx-auto flex flex-col justify-around my-16 p-0">

              <button @click="activeAccordion = activeAccordion === 'reepay' ? '' : 'reepay'" class="payment-toggle-btn mx-auto p-16 px-16 fw-semibold bg-darkblue text-white border-none flex justify-center items-center cursor-pointer">
                <span class="mx-16 fs-16">Reepay</span>
              </button>
              <div v-show="activeAccordion === 'reepay'" class="payment-collapse mx-auto bg-lightgrey">
                <div id="rp_container" class="payment-collapse mx-auto p-0" style="height: 462px;"></div>
              </div>

              <button @click="activeAccordion = activeAccordion === 'leveran' ? '' : 'leveran'" class="payment-toggle-btn mx-auto p-16 px-16 fw-semibold bg-darkblue text-white border-none flex justify-center items-center cursor-pointer">
                <span class="fs-16 mb-0 mr-16">Leverandørservice</span>
                <span v-if="activeAccordion !== 'leveran'" class="relative" style="top: 3px;">
                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16"><path d="M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z" /></svg>
                </span>
                <span v-else class="relative" style="top: 3px;">
                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="16" height="16"><path d="M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z" /></svg>
                </span>
              </button>
              <div v-show="activeAccordion === 'leveran'" class="payment-collapse mx-auto bg-lightgrey">
                <div class="flex justify-start">
                  <div class="w-100 p-0">

                    <div v-if="levandorupdate !== ''" class="my-16 p-12 bg-green text-white" style="border-radius: 6px;">
                      <div class="fw-semibold">Tak! Din konto hos Leverandørservice er nu integreret med Håndværker.dk.</div>
                    </div>

                    <form class="pt-8 pb-8 p-0" @submit.prevent="service_levendor">
                      <div class="w-100 flex flex-wrap mt-16 p-0">
                        <div class="w-50 xs-w-100 mb-16">
                          <label class="block mb-4 fs-14 fw-semibold" for="konto">Din Bank</label>
                          <select v-model="bank" required class="w-100">
                            <option v-for="opt in options" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
                          </select>
                          <span class="fs-12 text-grey block mt-4">Hvis din bank ikke er på listen, kan du ikke oprette forbindelse til leverandørservice</span>
                        </div>
                        <div class="w-50 xs-w-100 mb-16">
                          <label class="block mb-4 fs-14 fw-semibold" for="regnr">Registreringsnr.</label>
                          <input id="regnr" type="number" v-model="regnr" required placeholder="" maxlength="4" class="w-100" autocomplete="off" />
                          <span class="fs-12 text-grey block mt-4">Indsæt venligst din Registreringsnr (4 kar)</span>
                        </div>
                        <div class="w-50 xs-w-100 mb-16">
                          <label class="block mb-4 fs-14 fw-semibold" for="account">Bankkonto</label>
                          <input id="account" type="number" v-model="bankkonto" required placeholder="" maxlength="10" class="w-100" autocomplete="off" />
                          <span class="fs-12 text-grey block mt-4">Indsæt venligst din Bankkonto (10 kar)</span>
                        </div>
                        <div class="w-50 xs-w-100 mb-16">
                          <label class="block mb-4 fs-14 fw-semibold" for="cvr">CVR-nummer</label>
                          <input id="cvr" type="number" v-model="cvr" required placeholder="" class="w-100" autocomplete="off" />
                        </div>
                      </div>
                      <div class="pt-8 pb-8"></div>
                      <div class="mb-16">
                        <label class="flex items-center gap-8 cursor-pointer">
                          <input type="checkbox" v-model="consent" true-value="accepted" false-value="not_accepted" required />
                          <span class="text-grey fs-14">Jeg acceptere LeverandørService <a target="_blank" href="https://www.nets.eu/dk-da/SiteCollectionDocuments/leverandoerservice/LS_Regler_DB_debitor_regler_DK.pdf">reglerne</a></span>
                        </label>
                      </div>
                      <div class="pt-8 pb-8"></div>
                      <div v-if="levandorupdate === ''">
                        <button type="submit" class="bg-green text-white border-none p-8 px-16 cursor-pointer flex items-center gap-8 fw-semibold fs-16" style="border-radius: 4px;">
                          <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="24" height="24"><path d="M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm3.175-9.976l-2.122 2.121a1 1 0 0 0 1.414 1.414l2.829-2.828a1 1 0 0 0 0-1.414l-2.829-2.829a1 1 0 1 0-1.414 1.415l2.122 2.12zm-4.99 0l-2.121 2.121a1 1 0 0 0 1.414 1.414l2.828-2.828a1 1 0 0 0 0-1.414L7.478 6.488a1 1 0 0 0-1.414 1.415l2.121 2.12z" /></svg>
                          <span>Gem</span>
                        </button>
                      </div>
                      <div v-else class="p-12 bg-lightgrey" style="border-radius: 6px;">
                        <div class="flex flex-col">
                          <div class="w-100"><el-icon class="text-green"><CircleCheckFilled /></el-icon> Sidste opdatering : {{ levandorupdate }}</div>
                          <div class="w-100"><el-icon class="text-green"><CircleCheckFilled /></el-icon> Du kan opdaterer dine bankoplysninger 4 dage fra sidste gang du har gemt dem</div>
                        </div>
                      </div>
                      <div class="pt-8 pb-8"></div>
                    </form>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="w-100 p-16 bg-white">
        <p>Hvis du har spørgsmål eller tror, ​​der er en fejl, så ring eller e-mail support.</p>
      </div>
    </AppModal>

    <!-- Modal 2: Initial Reminder -->
    <AppModal v-model="initialreminderVisible" position="center" :no-close-on-backdrop="true">
      <div class="py-8"></div>
      <div class="bg-white w-100">
        <div class="border shadow payment-inner mx-auto my-16" style="border-radius: 6px;">
          <div class="w-100 flex justify-end my-16">
            <button type="button" @click="hidemodalinitial()" class="fs-24 bg-white border-none cursor-pointer">
              <svg xmlns="http://www.w3.org/2000/svg" width="17.633" height="17.632" viewBox="0 0 17.633 17.632">
                <path d="M-3642.184-128.272a8.815,8.815,0,0,1,8.816-8.816,8.815,8.815,0,0,1,8.817,8.816,8.815,8.815,0,0,1-8.817,8.816A8.815,8.815,0,0,1-3642.184-128.272Zm3.421-5.4a7.583,7.583,0,0,0-2.234,5.4,7.583,7.583,0,0,0,2.234,5.4,7.579,7.579,0,0,0,5.4,2.234,7.576,7.576,0,0,0,5.4-2.234,7.579,7.579,0,0,0,2.234-5.4,7.579,7.579,0,0,0-2.234-5.4,7.576,7.576,0,0,0-5.4-2.234A7.579,7.579,0,0,0-3638.763-133.668Zm2.2,8.588a.655.655,0,0,1,0-.958l2.233-2.234-2.233-2.234a.654.654,0,0,1,0-.958.648.648,0,0,1,.957,0l2.234,2.234,2.234-2.234a.681.681,0,0,1,.958,0,.682.682,0,0,1,0,.958l-2.234,2.234,2.234,2.234a.673.673,0,0,1,0,.958.681.681,0,0,1-.958,0l-2.234-2.234-2.234,2.234a.678.678,0,0,1-.48.2A.671.671,0,0,1-3636.559-125.08Z" transform="translate(3642.184 137.088)" fill="#499dbb"/>
              </svg>
            </button>
          </div>
          <div class="flex flex-col justify-start w-100 p-24">
            <p class="my-16 text-darkblue">
              <svg xmlns="http://www.w3.org/2000/svg" width="130" height="130" viewBox="0 0 116.96 92.339">
                <path d="M12.879,79.46A43.971,43.971,0,0,1,43.971,4.4,43.477,43.477,0,0,1,64.058,9.244,44.327,44.327,0,0,1,79.3,22.183a2.633,2.633,0,0,1,2.429.222L85.919,25.1l4.062-2.311a2.637,2.637,0,0,1,3.941,2.292V69.358A2.637,2.637,0,0,1,89.9,71.6L85.884,69.12l-4.125,2.735a2.631,2.631,0,0,1-.845.367A43.976,43.976,0,0,1,12.879,79.46Zm3.729-58.455A38.694,38.694,0,1,0,71.33,75.728a39.161,39.161,0,0,0,4.711-5.689l-1.371-.89-4.03,2.7a2.641,2.641,0,0,1-2.884.035L63.45,69.149l-3.919,2.685A2.637,2.637,0,0,1,55.4,69.659V24.624a2.638,2.638,0,0,1,4.1-2.2l3.948,2.625,4.337-2.675a2.65,2.65,0,0,1,2.821.035l4.059,2.64,4.23-2.659-4.1,2.577a39.28,39.28,0,0,0-3.467-3.964,38.7,38.7,0,0,0-54.722,0ZM80.255,72.3a2.668,2.668,0,0,1-1.39-.424A2.644,2.644,0,0,0,80.255,72.3ZM64.809,63.761l4.325,2.748L73.176,63.8a2.641,2.641,0,0,1,2.906-.019l4.2,2.726,4.093-2.713a2.638,2.638,0,0,1,2.846-.044l1.425.88V29.617l-1.507.858a2.633,2.633,0,0,1-2.732-.073l-4.125-2.65-4.233,2.662a2.623,2.623,0,0,1-1.406.405,2.652,2.652,0,0,1-1.437-.424l-4.074-2.65L64.78,30.427a2.639,2.639,0,0,1-2.846-.047l-1.254-.836V64.65l1.222-.839a2.649,2.649,0,0,1,1.494-.462A2.616,2.616,0,0,1,64.809,63.761Zm-33.362-1.1a1.972,1.972,0,1,1,1.969,1.972A1.97,1.97,0,0,1,31.447,62.665Zm33.631-5.5a1.76,1.76,0,1,1,0-3.52H75.629a1.76,1.76,0,0,1,0,3.52ZM31.69,54.776l-1.232-19.72a2.959,2.959,0,0,1,5.917,0l-1.295,19.72c0,1.634-.8,2.219-1.665,2.219S31.69,56.409,31.69,54.776Zm42.182-6.408a1.759,1.759,0,1,1,1.757,1.757A1.758,1.758,0,0,1,73.872,48.368Zm-8.795,1.757a1.759,1.759,0,1,1,0-3.517h3.517a1.759,1.759,0,1,1,0,3.517Zm0-7.035a1.759,1.759,0,1,1,0-3.517H79.147a1.759,1.759,0,1,1,0,3.517ZM103.771,29.9a2.637,2.637,0,1,1,0-5.274h10.552a2.637,2.637,0,0,1,0,5.274ZM98.386,18.574a2.639,2.639,0,0,1,0-3.729L108.941,4.29a2.638,2.638,0,0,1,3.729,3.733L102.118,18.574a2.641,2.641,0,0,1-3.733,0ZM87.061,13.192V2.637a2.639,2.639,0,0,1,5.278,0V13.192a2.639,2.639,0,0,1-5.278,0Z" fill="#19a3c0"/>
              </svg>
            </p>
            <p class="fw-semibold fs-20 text-darkblue pt-8">Hovsa! Din betaling til <a href="https://www.haandvaerker.dk" target="_blank">Håndværker.dk</a> mislykkedes.</p>
            <p class="fs-16 text-darkblue py-8">Vi kunne ikke behandle din sidste betaling. Din konto forbliver aktiv, men opdater venligst dine kreditkortoplysninger for at undgå suspendering.</p>
            <button @click="showmodal(), hidemodalinitial(), showsessionnewcredit()" class="mb-16 mt-24 py-8 bg-green text-white border-none cursor-pointer flex justify-center items-center" style="border-radius: 4px; max-width: 250px;">
              <span class="mx-16 my-8">Opdater kreditkort</span>
            </button>
            <div class="w-100 flex flex-wrap p-0">
              <p>Hvis du har spørgsmål eller tror, ​​der er en fejl, så
                <a href="tel:+45#4570228014">ring</a> eller
                <a href="mailto:support@haandvaerker.dk">e-mail</a> support.
              </p>
            </div>
          </div>
        </div>
      </div>
    </AppModal>

    <!-- Modal 3: Success -->
    <AppModal v-model="sendingsuccessVisible" position="center" :no-close-on-backdrop="true">
      <div class="py-8"></div>
      <div class="bg-white m-16">
        <div class="flex flex-col w-100">
          <p class="my-16 text-darkblue mx-auto"><el-icon class="text-green" style="font-size: 4em;"><CircleCheckFilled /></el-icon></p>
          <p class="fw-semibold fs-24 text-darkblue pt-8 mx-auto">Tak for din henvendelse,</p>
          <p class="fs-20 text-darkblue py-8 mx-auto">Vi ringer til dig hurtigst muligt</p>
          <button @click="hidemodaltak('')" class="my-16 mx-auto bg-darkblue text-white border-none cursor-pointer flex justify-center items-center p-8 px-16" style="border-radius: 4px;">
            <span class="mx-16 my-8">Luk</span>
          </button>
        </div>
      </div>
    </AppModal>

    <ErrorHandler ref="errorMsg"></ErrorHandler>
  </div>
</template>
<script setup>
import { loadReepaySdk } from '@/utility/loadReepaySdk'
import { ElIcon } from 'element-plus'
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'
import ErrorHandler from '@/components/ErrorHandler'
import AppModal from '@/components/AppModal.vue'
import { captureApiException } from '@/utility/sentry'
import { CircleCheckFilled } from '@element-plus/icons-vue'

const props = defineProps({
    eligibilitydata: {
        type: [Object, Array, String],
        required: false,
        default: null
    }
})

const emit = defineEmits(['Nopaymentmethod'])
const router = useRouter()
const bitrixApi = import.meta.env.VITE_BITRIXAPI

// State
const salesPerson = ref(localStorage.getItem('id_token_portal'))
const haaId = ref(localStorage.getItem('haaid'))
const showreminder = ref('')
const partnername = ref(localStorage.getItem('CompanyName'))
const hasleveran = ref('')
const regnr = ref('')
const bankkonto = ref('')
const help = ref('')
const cvr = ref('')
const bank = ref('')
const consent = ref('')
const levandorupdate = ref('')
const options = ref([])
const rp = ref('')
const showsessionnewcreditpro = ref('')
const shownewcreditpro = ref(false)
const dunninginvoice = ref('')
const perndinginvoice = ref('')
const datamethod = ref('')
const leverandordate = ref('')
const show = ref(false)

// Template refs
const errorMsg = ref(null)
const simplert = ref(null)

// Modal visibility
const paymentmethodsVisible = ref(false)
const initialreminderVisible = ref(false)
const sendingsuccessVisible = ref(false)
const activeAccordion = ref('reepay')

// Computed
const regState = computed(() => regnr.value.length === 4)
const bankState = computed(() => bankkonto.value.length === 10)

// Methods
function showmodal () {
    paymentmethodsVisible.value = true
}

function showmodalinitial () {
    initialreminderVisible.value = true
}

function hidemodal () {
    paymentmethodsVisible.value = false
}

function hidemodalinitial () {
    initialreminderVisible.value = false
}

function hidemodalsuccess () {
    sendingsuccessVisible.value = false
}

function hidemodaltak () {
    sendingsuccessVisible.value = false
}

function goto () {
    router.push(props.partnerData['linkreferer'])
}

function limitbankno (e) {
    return String(e).substring(0, 10)
}

function limitbankregis (e) {
    return String(e).substring(0, 4)
}

async function checkleveranpartner () {
    var dataPartner = {operation: 'oversigt_partner_profil', salesPerson: salesPerson.value, typeMeeting: '1'}
    try {
        const response = await axios.post('', dataPartner)
        var res = response.data
        if (res.login === false) {
            router.push('/login')
        }
        cvr.value = res.cvr
        if (res.levandorupdate === '') {
            hasleveran.value = false
            levandorupdate.value = res.levandorupdate
        } else {
            hasleveran.value = true
        }
        if (haaId.value === '40035' || haaId.value === '10247') {
            hasleveran.value = false
            levandorupdate.value = ''
        }
        regnr.value = res.levandorregnr
        bankkonto.value = res.levandorbankkonto
        options.value = res.bankOptions
        leverandordate.value = res.levandorupdate
        getpartnerinvoicedue()
    } catch (error) {
        captureApiException(error, 'paymentreminderpopup.vue', 'checkleveranpartner')
        alert('error')
    }
}

function processingperiod (a = '') {
    const datenow = new Date()
    const processingstart = new Date(a)
    const processingend = new Date(a)
    processingend.setDate(processingstart.getDate() + 5)
    if (datenow.getTime() >= processingstart.getTime() && datenow.getTime() <= processingend.getTime()) {
        return false
    } else {
        return true
    }
}

async function service_levendor () {
   show.value = true
    salesPerson.value = localStorage.getItem('id_token_portal')
    var dataPartner = {operation: 'service_levendor', salesPerson: salesPerson.value, regnr: regnr.value, bankkonto: bankkonto.value, levid: haaId.value, cvr: cvr.value, bank: bank.value}
    try {
        const response = await axios.post('', dataPartner)
        var res = response.data
       show.value = false
        if (res.login === false) {
            router.push('/login')
        }
        if (res.success) {
            let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success'
            }
            simplert.value.openSimplert(obj)
        } else {
            alert(res.message)
        }
    } catch (error) {
        captureApiException(error, 'paymentreminderpopup.vue', 'service_levendor')
        alert('error')
    }
}

async function partnerinfo () {
    var headers = {
        Authorization: 'Bearer ' + salesPerson.value
    }
    try {
        const response = await axios.get(bitrixApi + 'reepay/getPartnerInfo/' + haaId.value, {headers})
        var res = response.data
        if (res.success) {
            partnername.value = res.data.company
            dunninginvoice.value = res.data.dunning_invoices
            perndinginvoice.value = res.data.pending_invoices
        }
    } catch (error) {
        captureApiException(error, 'paymentreminderpopup.vue', 'partnerinfo')
        console.log('Error: ', error)
    }
}

async function getpartnerinvoice () {
    haaId.value = localStorage.getItem('haaid')
    var headers = {
        Authorization: 'Bearer ' + salesPerson.value
    }
    try {
        const response = await axios.get(bitrixApi + 'reepay/getPartnerInvoice/' + haaId.value, {headers})
        var res = response.data
        if (res.success) {
            var checkinvoices = res.data.content
            var dunninginvoices = checkinvoices.filter((item) => item.state === 'pending')
            var pendinginvoices = checkinvoices.filter((item) => item.state === 'dunning')
            dunninginvoice.value = dunninginvoices.length
            perndinginvoice.value = pendinginvoices.length
            if (dunninginvoice.value > 0 || perndinginvoice.value > 0) {
                showreminder.value = 'true'
                emit('Nopaymentmethod', showreminder.value)
            }
        }
    } catch (error) {
        captureApiException(error, 'paymentreminderpopup.vue', 'getpartnerinvoice')
        errorMsg.value.showMsg(error.data)
    }
}

async function getpartnerinvoicedue () {
    if (check4hour()) {
        haaId.value = localStorage.getItem('haaid')
        var headers = {
            Authorization: 'Bearer ' + salesPerson.value
        }
        if (haaId.value === '40035' && (bitrixApi === bitrixApi + '' || bitrixApi === bitrixApi + '')) {
            haaId.value = '140035'
        }
        try {
            const response = await axios.get(bitrixApi + 'reepay/getPartnerInvoiceDue/' + haaId.value, {headers})
            var res = response.data
            if (res.success) {
                var checkinvoices = res.data.content
                var dunninginvoices = checkinvoices.filter((item) => item.state === 'dunning')
                var pendinginvoices = checkinvoices.filter((item) => item.state === 'pending')
                dunninginvoice.value = dunninginvoices.length
                perndinginvoice.value = pendinginvoices.length
                if ((dunninginvoice.value >= 1 || perndinginvoice.value) && processingperiod(leverandordate.value)) {
                    showreminder.value = 'true'
                    emit('Nopaymentmethod', showreminder.value)
                }
            }
        } catch (error) {
            captureApiException(error, 'paymentreminderpopup.vue', 'getpartnerinvoicedue')
            errorMsg.value.showMsg(error.data)
        }
    }
}

async function getpartnerinvoicebystatus () {
    var headers = {
        Authorization: 'Bearer ' + salesPerson.value
    }
    try {
        const response = await axios.get(bitrixApi + 'reepay/getPartnerInvoice/' + haaId.value + '?status=dunning', {headers})
        var res = response.data
    } catch (error) {
        captureApiException(error, 'paymentreminderpopup.vue', 'getpartnerinvoicebystatus')
        errorMsg.value.showMsg(error.data)
    }
}

async function getpartnerpaymentmethod () {
    if (check4hour()) {
        var headers = {
            Authorization: 'Bearer ' + salesPerson.value
        }
        try {
            const response = await axios.get(bitrixApi + 'reepay/getPartnerPaymentMethod/' + haaId.value, {headers})
            var res = response.data
            if (res.success) {
                if (!hasleveran.value) {
                    var cards = res.data.cards
                    var activecards = cards.filter((item) => item.state === 'active')
                    if (activecards.length === 0) {
                        showreminder.value = 'true'
                        emit('Nopaymentmethod', showreminder.value)
                    }
                }
                if (dunninginvoice.value > 0 || (perndinginvoice.value > 0)) {
                    showreminder.value = 'true'
                    emit('Nopaymentmethod', showreminder.value)
                }
            } else {
                errorMsg.value.showMsg(res.message)
            }
        } catch (error) {
            captureApiException(error, 'paymentreminderpopup.vue', 'getpartnerpaymentmethod')
            errorMsg.value.showMsg(error.data)
        }
    }
}

async function getpartnersubsciption () {
    var headers = {
        Authorization: 'Bearer ' + salesPerson.value
    }
    try {
        const response = await axios.get(bitrixApi + 'reepay/getPartnerSubsciption/' + haaId.value, {headers})
        var res = response.data
    } catch (error) {
        captureApiException(error, 'paymentreminderpopup.vue', 'getpartnersubsciption')
        errorMsg.value.showMsg(error.data)
    }
}

async function shownewcredit () {
    var data = {
        operation: 'newcredit',
        salesPerson: salesPerson.value
    }
    try {
        const response = await axios.post('', data)
        var res = response.data
        if (res.login === false) {
            router.push('/login')
        }
        shownewcreditpro.value = true
    } catch (error) {
        captureApiException(error, 'paymentreminderpopup.vue', 'shownewcredit')
        console.error(error)
    }
}

async function showsessionnewcredit () {
    try {
        const response = await axios.post(bitrixApi + 'reepay/recurringSession?partnerId=' + haaId.value)
        var res = response.data
        if (res.login === false) {
            router.push('/login')
        }
        if (res.success) {
            var data = res.data
            showsessionnewcreditpro.value = data.id
            await showpopupreepay()
        } else {
            errorMsg.value.showMsg(res.message)
        }
    } catch (error) {
        captureApiException(error, 'paymentreminderpopup.vue', 'showsessionnewcredit')
        errorMsg.value.showMsg(error.data)
    }
}

async function showpopupreepay () {
    await loadReepaySdk()
    rp.value = new window.Reepay.EmbeddedCheckout(showsessionnewcreditpro.value, { html_element: 'rp_container', showReceipt: true })
    rp.value.addEventHandler(window.Reepay.Event.Accept, function (data) {
        datamethod.value = data.payment_method
        console.log('done adding card', data)
        setTimeout(() => {
            wait4hourreminder()
        }, 5000)
    })
}

function destroyrd () {
    rp.value.destroy(showsessionnewcreditpro.value)
}

async function preloadrp () {
    await loadReepaySdk()
    rp.value = new window.Reepay.EmbeddedCheckout(null, { html_element: 'rp_container', showReceipt: true })
}

function showrp () {
    rp.value.show(showsessionnewcreditpro.value, { html_element: 'rp_container', showReceipt: true })
}

function wait4hourreminder () {
    const timenow = new Date()
    const timeafter4hour = new Date()
    timeafter4hour.setHours(timenow.getHours() + 4)
    localStorage.removeItem('timeaddedcard')
    localStorage.removeItem('timeaddedcardexpiry')
    localStorage.setItem('timeaddedcard', timenow)
    localStorage.setItem('timeaddedcardexpiry', timeafter4hour)
    emit('Nopaymentmethod', 'false')
}

function check4hour () {
    const timeaccessnow = new Date()
    var togettime = localStorage.getItem('timeaddedcard')
    var togettimeexpiry = localStorage.getItem('timeaddedcardexpiry')
    const togettimenew = new Date(togettime)
    const togettimeexpirynew = new Date(togettimeexpiry)
    if (togettime !== null && togettimeexpiry !== null) {
        if (timeaccessnow.getTime() > togettimenew.getTime() && timeaccessnow.getTime() < togettimeexpirynew.getTime()) {
            return false
        } else {
            return true
        }
    } else {
        return true
    }
}

defineExpose({
    showmodal,
    showmodalinitial,
    hidemodal,
    hidemodalinitial,
    hidemodalsuccess,
    checkleveranpartner,
    partnerinfo,
    getpartnerinvoice,
    getpartnerinvoicebystatus,
    getpartnersubsciption,
    getpartnerpaymentmethod,
    shownewcredit,
    showsessionnewcredit,
    showpopupreepay,
    destroyrd,
    preloadrp,
    showrp
})
</script>
<style scoped>
.payment-inner {
  width: 83.33%;
}
.payment-toggle-btn {
  width: 66.66%;
  border-radius: 0;
}
.payment-collapse {
  width: 66.66%;
}
@media (max-width: 576px) {
  .payment-inner {
    width: 100%;
  }
  .payment-toggle-btn {
    width: 100%;
  }
  .payment-collapse {
    width: 100%;
  }
}
@media (max-width: 570px) {
  .rp-content-section-details-row {
    flex-direction: column;
  }
}
</style>
